<template>
  <div class="item">
    <div class="item__head aspect-ratio aspect-ratio--1-1 bg-transparent" @click="goDetail(dataSource)">
      <div class="img__wrap" v-if="dataSource.thumbnail">
        <img :src="dataSource.thumbnail ? handleResizeImg(dataSource.thumbnail) : img404" :alt="dataSource.name">
      </div>
    </div>
    <div class="item__body">
      <h4 class="item__title primary-color-txt font-sanpro-semibold font-size-17 text-center" @click="goDetail(dataSource)">{{ dataSource.name }}</h4>
      <div
        class="item__meta text-center font-size-14"
        :class="{
          'secondary-color': dataSource.isWork && dataSource.isWork === statusDone,
          'four-color': dataSource.isWork && dataSource.isWork === statusWorking,
          'secondary-color-txt': dataSource.isWork && dataSource.isWork === statusDontWork
        }"
      >
        <span class="item__status">{{ checkTypeExam(dataSource.isWork) }}</span>
        <span class="item__meta__middle" v-if="dataSource.isWork && dataSource.isWork === statusDone">-</span>
        <span class="item__point" v-if="dataSource.isWork && dataSource.isWork === statusDone">{{ dataSource.score }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import { APP_CONFIG } from "@/utils/constants"
  import mixinExam from './../../_store/mixinExam'
  import { EXAM_WORKED_DONE, EXAM_WORKING, EXAM_DONT_WORK } from './../../_store/constants'
  import { replaceImageResize } from '@/helpers/functions'
  const img404 = require(`@/assets/images/img_404.jpg`)

  export default {
    name: 'ItemExam',
    mixins: [ mixinExam ],
    props: {
      dataSource: Object
    },
    data () {
      return {
        urlImg: APP_CONFIG.urlQuestionImg,
        img404,
        statusDone: EXAM_WORKED_DONE,
        statusWorking: EXAM_WORKING,
        statusDontWork: EXAM_DONT_WORK
      }
    },
    methods: {
      goDetail (val) {
        this.$router.push({ name: 'exerciseExamDetail', params: {classId: val.classId, subjectId: val.subjectId, id: val.examId} })
      },

      handleResizeImg (link) {
        return replaceImageResize(link, {width: 310, height: 343})
      }
    }
  }
</script>

<style lang="scss" scoped>
  .item {
    margin-bottom: 20px;

    &__body {
      padding: 10px 0;
    }
    
    &__meta {
      >* {
        &:not(:last-child) {
          margin-right: 5px;
        }
      }
    }

    &:hover {
      .item {
        &__title {
          @extend .primary-color;
        }

      }
    }
  }
</style>